module.exports = __webpack_public_path__ + "img/inspiration-2@2x.f2be094.jpg";